import homePlugin from '@backstage/plugin-home/alpha';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import { CAPABILITY_ROADMAPS, PLATFORM_CAPABILITIES } from './model';

// Replace only Home's rendering; keep the plugin, route ref, auth boundary and inputs.
export const horizonHomePlugin = homePlugin.withOverrides({
  extensions: [
    homePlugin.getExtension('page:home').override({
      params: {
        loader: () =>
          import('./CapabilityPages').then(m => <m.PlatformLandingPage />),
      },
    }),
  ],
});

export const horizonCapabilitiesPlugin = createFrontendPlugin({
  pluginId: 'horizon-capabilities',
  title: 'Horizon capabilities',
  extensions: [
    ...PLATFORM_CAPABILITIES.map(capability =>
      PageBlueprint.make({
        name: capability.id,
        params: {
          path: capability.path,
          title: capability.title,
          noHeader: true,
          icon:
            capability.id === 'migrate' ? (
              <FlightTakeoffIcon />
            ) : (
              <TrackChangesIcon />
            ),
          loader: () =>
            import('./CapabilityPages').then(m => (
              <m.CapabilityOverviewPage capability={capability} />
            )),
        },
      }),
    ),
    ...CAPABILITY_ROADMAPS.map(({ capability, module }) =>
      PageBlueprint.make({
        name: module.id,
        params: {
          path: module.path,
          title: module.title,
          noHeader: true,
          loader: () =>
            import('./CapabilityPages').then(m => (
              <m.CapabilityRoadmapPage
                capability={capability}
                module={module}
              />
            )),
        },
      }),
    ),
  ],
});
